import { bindActions } from "redux-zero/utils";
import store from "@store/store";

const actions = (store) => ({
  setProducts: (state, products) => ({
    products: { ...state.products, ...products },
  }),
  setReviews: (state, { id, reviews, user_likes, user_dislikes }) => {
    let existingReviewsData = state.reviews[id];

    if (
      existingReviewsData &&
      reviews.current_page > existingReviewsData.current_page
    ) {
      existingReviewsData = {
        ...reviews,
        data: [...existingReviewsData.data, ...reviews.data],
      };
    } else {
      existingReviewsData = reviews;
    }

    return {
      reviews: { ...state.reviews, [id]: existingReviewsData },
      user_likes: [...state.user_likes, ...user_likes],
      user_dislikes: [...state.user_dislikes, ...user_dislikes],
    };
  },
  toggleLikeAction: (state, { reviewId, productUid }) => {
    const isAddLikeAction = !state.user_likes.includes(reviewId);
    const isRemoveDislike = state.user_dislikes.includes(reviewId);

    return {
      user_dislikes: isAddLikeAction
        ? state.user_dislikes.filter((id) => id != reviewId)
        : state.user_dislikes,
      user_likes: isAddLikeAction
        ? [...state.user_likes, reviewId]
        : state.user_likes.filter((id) => id != reviewId),
      reviews: {
        ...state.reviews,
        [productUid]: {
          ...state.reviews[productUid],
          data: state.reviews[productUid].data.map((review) =>
            review.id === reviewId
              ? {
                  ...review,
                  likes_count: isAddLikeAction
                    ? review.likes_count + 1
                    : review.likes_count - 1,
                  dislikes_count: isRemoveDislike
                    ? review.dislikes_count - 1
                    : review.dislikes_count,
                }
              : review
          ),
        },
      },
    };
  },
  toggleDislikeAction: (state, { reviewId, productUid }) => {
    const isAddDislikeAction = !state.user_dislikes.includes(reviewId);
    const isRemoveLike = state.user_likes.includes(reviewId);

    return {
      user_likes: isAddDislikeAction
        ? state.user_likes.filter((id) => id != reviewId)
        : state.user_likes,
      user_dislikes: isAddDislikeAction
        ? [...state.user_dislikes, reviewId]
        : state.user_dislikes.filter((id) => id != reviewId),
      reviews: {
        ...state.reviews,
        [productUid]: {
          ...state.reviews[productUid],
          data: state.reviews[productUid].data.map((review) =>
            review.id === reviewId
              ? {
                  ...review,
                  dislikes_count: isAddDislikeAction
                    ? review.dislikes_count + 1
                    : review.dislikes_count - 1,
                  likes_count: isRemoveLike
                    ? review.likes_count - 1
                    : review.likes_count,
                }
              : review
          ),
        },
      },
    };
  },
});

export const boundActions = bindActions(actions, store);

export default actions;
